import { getCurrentInterestRateDetails } from 'common/interest-rate-components/base';
import { Link } from 'component-library/components/links/Link';
import { Body } from 'component-library/components/typography/Body';
import { graphql } from 'gatsby';
import { DepositAccountAgreementFragment as DepositAccountAgreementFragmentType } from 'graphqlTypes';
import React, { FC } from 'react';

import { FOOTNOTE_REFERENCES } from './utils';

export const DepositAccountAgreementFragment = graphql`
  fragment DepositAccountAgreement on Query {
    ...GetCurrentInterestRateDetails
  }
`;

interface DepositAccountAgreementProps {
  data: DepositAccountAgreementFragmentType;
}

export const DepositAccountAgreement: FC<DepositAccountAgreementProps> = ({
  data,
}) => {
  const { formattedInterestRate, formattedApy, effectiveDate } = getCurrentInterestRateDetails(data);

  return (
    <>
      <Body variant={5} marginBottom={12} marginTop={12}>
        {FOOTNOTE_REFERENCES.asterisk} The interest rate on Retirable Consumer Deposit Account Tier 2 is {formattedInterestRate} with 
        Annual Percentage Yield (APY) of {formattedApy}. The interest rates are accurate as of 
        {new Date(effectiveDate).toLocaleDateString('en-us', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        })}
        . Rate is variable and is subject to change after account opening. Fees may reduce earnings.
      </Body>
      <Body variant={5} marginBottom={12}>
        {FOOTNOTE_REFERENCES.doubleAsterisk} Refer to the fee schedule in your{' '}
        <Link inline variant={5} to="/legal/consumer-deposit-account-agreement">
          Consumer Deposit Account Agreement
        </Link>
      </Body>
    </>
  );
};
